/* eslint-disable no-console */
/* eslint-disable max-len */

import { roleCondition } from '../../../../../../../libs/HelperContent';

export const getCompanyActive = (companyUser) =>
{
	const { socialMediaConfiguration } = companyUser;

	const activeKeys = [
		{ key: 'isLinkedIn', apiKey: 'linkedIn', name: 'linkedIn' },
		{ key: 'isTwitter', apiKey: 'twitter', name: 'xTwitter' }
	].filter((Obj) => Boolean(socialMediaConfiguration?.[Obj?.key]));

	let res:any;

	if (activeKeys?.length > 0)
	{
		res = activeKeys.map((activeObjs) => socialMediaConfiguration?.hasOwnProperty([ activeObjs?.apiKey ]) &&
        { apiKey: activeObjs?.apiKey, ...socialMediaConfiguration?.[activeObjs?.apiKey], name: activeObjs?.name }).filter(Boolean);
	}
	else
	{
		res = [];
	}

	return res;
};

export const getUserActive = (companyUser, currentUser) =>
{
	const companySocialMediaConfiguration = companyUser?.socialMediaConfiguration;
	const employeeSocialMediaConfiguration = currentUser?.socialMediaConfiguration;

	const activeKeys = [
		{ key: 'isLinkedIn', apiKey: 'linkedIn', name: 'linkedIn' },
		{ key: 'isTwitter', apiKey: 'twitter', name: 'xTwitter' }
	].filter((Obj) => Boolean(companySocialMediaConfiguration?.[Obj?.key] && employeeSocialMediaConfiguration?.[Obj?.key] && employeeSocialMediaConfiguration?.[Obj?.key]));

	let res:any;

	if (activeKeys?.length > 0)
	{
		res = activeKeys.map((activeObjs) => employeeSocialMediaConfiguration?.hasOwnProperty([ activeObjs?.apiKey ]) &&
        { apiKey: activeObjs?.apiKey, ...employeeSocialMediaConfiguration?.[activeObjs?.apiKey], name: activeObjs?.name }).filter(Boolean);
	}
	else
	{
		res = [];
	}

	return res;
};

export const getSocialAccDetails = (companyUser, currentUser, userData, createFeedAs, requestT) =>
{
	const getData = (roleCondition(userData?.empRole) && createFeedAs === 'company')
		? getCompanyActive(companyUser)
		: getUserActive(companyUser, currentUser);

	if (getData?.length > 0)
	{
		const Socialaccnts = getData?.map((accnt) =>
		{
			return {
				apiKey   : accnt?.apiKey,
				isActive : accnt?.isActive,
				name     : accnt?.name
			};
		}).filter((accnt) => accnt?.isActive);

		return { Socialaccnts };
	}
	else
	{
		return { Socialaccnts: [] };
	}
};
